import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import _last from 'lodash/last';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import LabelsStyles from './__styles__/Labels.styles';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';

import Shipper from './Shipper';
import ShipmentInfo from './ShipmentInfo';
import LabelBarcode from './Barcode';
import Delivery from './Delivery';

class Package extends Component {
  static propTypes = {
    unit: PropTypes.object.isRequired,
    itemIndex: PropTypes.number.isRequired,
    shipment: PropTypes.object.isRequired,
    totPackages: PropTypes.number.isRequired,
    totUnits: PropTypes.number.isRequired
  };

  render() {
    const { shipment, unit, itemIndex, classes, totPackages } = this.props;

    const pickup = shipment.stops[0];
    const delivery = _last(shipment.stops);

    return (
      <Fragment>
        <div className={classes.pageBreak}>
          <Grid container spacing={16} className={classes.labelFont}>
            <Shipper pickup={pickup} />
            <Grid item xs={1} />
            <ShipmentInfo
              shipment={shipment}
              itemIndex={itemIndex}
              unit={unit}
              totPackages={totPackages}
            />
          </Grid>
          <LabelBarcode proNumber={shipment.proNumber} />
          <Grid container spacing={16}>
            <Delivery
              delivery={delivery}
              billToInfo={shipment.billToInfo}
              carrier={
                shipment.selectedShipmentRate
                  ? shipment.selectedShipmentRate.carrier
                  : null
              }
            />
          </Grid>
        </div>
      </Fragment>
    );
  }
}

export default withStyles(
  combineStyles(
    LabelsStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(Package);
